import { toastr } from "react-redux-toastr";

// Imports 
import { doRequest } from "../../modules/request";
import { deleteState, loadState, saveState } from "../../modules/localStorage";

export const RECEIVE_NEWSESSION = "RECEIVE_NEWSESSION";
export const ERROR_NEWSESSION = "ERROR_NEWSESSION";
export const START_SESSION = "START_SESSION";

export function ListaMeioPagamento(
  Cliente_ID,
  LoginLE,
  TokenLE,
  SessionIDLE,
  chrCodigoPonto,
  chrCodigoOperador,
  callback = null
) {
  const params = {
    url: "/ListarMetodosPagamento",
    method: "POST",
    data: { Cliente_ID, LoginLE, TokenLE, SessionIDLE, chrCodigoPonto, chrCodigoOperador, sdtDataHoraTerminal: new Date().toISOString() },
  };

  return doRequest(params)
    .then((response) => {
      if (response.intCodigoRetorno > 0 || response.isError) {
        toastr.error("Erro", response.strErrorMessage);
      }

      if (callback) callback(response);

    })
    .catch((error) => {
      toastr.error("Falha ao iniciar nova sessão.", error.message);

      if (callback) callback(error);

    });
}

export function newSession(
  Cliente_ID,
  LoginLE,
  TokenLE,
  SessionIDLE,
  chrCodigoPonto,
  chrCodigoOperador,
  CID,
  callback = null,
  siteId
) {
  const params = {
    url: "/NewSession",
    method: "POST",
    data: { CID, Cliente_ID, LoginLE, TokenLE, SessionIDLE, chrCodigoPonto, chrCodigoOperador },
  };

  if(siteId) params.data.Site_ID = Number(siteId);
  
  const previousParams = loadState("new-session-params");
  const currentParams = `CID=${CID}&clientId=${Cliente_ID}&ponto=${chrCodigoPonto}&operador=${chrCodigoOperador}`;
  saveState(currentParams, "new-session-params");

  if (previousParams && previousParams !== currentParams) {
    deleteState("contest-rifa");
    deleteState("contest");
  }

  return doRequest(params)
    .then((response) => {
      if (response.intCodigoRetorno > 0) {
        toastr.error("Erro", response.strErrorMessage);
      }

      const responseWithCID = {...response, CID, Site_ID: siteId, ChrCodigoPonto: chrCodigoPonto || response.ChrCodigoPonto , ChrCodigoOperador: chrCodigoOperador || response.ChrCodigoOperador};
      window["wweb-session"] = responseWithCID;

        if (callback) callback(responseWithCID);

      return {
        type: RECEIVE_NEWSESSION,
        payload: responseWithCID,
      };
    })
    .catch((error) => {
      toastr.error("Falha ao iniciar nova sessão.", error.message);

      if (callback) callback(error);

      return {
        type: ERROR_NEWSESSION,
        payload: error.message,
      };
    });
}

export function restartSession(
  Cliente_ID,
  LoginLE,
  TokenLE,
  SessionIDLE
) {
  const params = {
    url: "/StartSession",
    method: "POST",
    data: { Cliente_ID, LoginLE, TokenLE, SessionIDLE },
  };

  return doRequest(params)
    .then((response) => {
      if (response.intCodigoRetorno > 0) {
        toastr.error("Erro", response.strErrorMessage);
      }
    });
}

export function startSession(objUser) {
  return {
    type: START_SESSION,
    payload: objUser,
  };
}



// WEBPACK FOOTER //
// ./src/reducers/usuario/usuarioActions.js